(ns common.i18n.plural
  "Plural forms of a translation.

   Languages have different numbers of plural forms. English and Finnish have
   two. Polish and Russian have more. This namespace selects the form with the
   CLDR plural categories, the same categories that `Intl.PluralRules` uses.

   A plural translation has one dictionary key for each category. The key of a
   form is the base key with the category as its name part, for example
   :kanban-column-item-count/one and :kanban-column-item-count/other. The
   :other form is mandatory in every language.

   To add a language, add one entry to `locale-rules`. Give it the CLDR rule
   and the categories that the rule can return.")

(def categories
  "All CLDR plural categories."
  #{:zero :one :two :few :many :other})

(defn- one-or-other
  "CLDR rule for English and Finnish. Return :one for exactly 1, and :other for
   all other numbers."
  [n]
  (if (== 1 n)
    :one
    :other))

(def locale-rules
  "The plural rule of each supported locale. :rule takes a number and returns a
   category. :categories lists every category that the rule can return."
  {:en {:rule       one-or-other
        :categories [:one :other]}
   :fi {:rule       one-or-other
        :categories [:one :other]}})

(def plural-keys
  "Every base key that has plural forms. Add a new base key here, so that the
   tests check its forms in every locale."
  #{:kanban-column-item-count
    :confirm-delete-selected-count})

(defn plural-category
  "Return the plural category of the number n in the locale lang. Use the
   English rule for a locale that has no rule. Return :other when n is not a
   number."
  [lang n]
  (let [{:keys [rule]} (get locale-rules lang (:en locale-rules))]
    (if (number? n)
      (rule n)
      :other)))

(defn form-key
  "Return the dictionary key of one plural form of the base key k, for example
   :kanban-column-item-count/one. A base key with a namespace keeps it as a
   prefix, so :a/b and :b have different forms."
  [k category]
  (keyword (if-let [ns-part (namespace k)]
             (str ns-part "." (name k))
             (name k))
           (name category)))

(defn form-keys
  "Return the dictionary keys to try for a number, in order. First the form of
   its category, then the :other form."
  [{:keys [translation-key lang quantity]}]
  (->> [(plural-category lang quantity) :other]
       distinct
       (mapv (partial form-key translation-key))))
